import { render, staticRenderFns } from "./HomeNewsList.vue?vue&type=template&id=48fc7949&"
import script from "./HomeNewsList.vue?vue&type=script&lang=js&"
export * from "./HomeNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports